"use strict";
// packages/types/src/api/affiliate.ts
Object.defineProperty(exports, "__esModule", { value: true });
